import React from 'react';
import PropTypes from 'prop-types';
import ColumnedSection from '../right-pane/columned-section';
import { withStyles } from '@material-ui/core';
import { translate } from '../utils/translation-utils';

const styles = theme => ( {
    logoContainer: {
        '& img': {
            maxWidth: '40%',
        },
        paddingBottom: theme.spacing.unit,
        textAlign: 'center',
        width: '100%',
    },
} );

const SenderDetailsTabProfile = ( { classes, senderData } ) => {
    const allProfileData = [
        { automationId: 'sender-details-profile-support-email', title: 'Support Email', value: senderData.supportEmail },
        { automationId: 'sender-details-profile-support-phone', title: 'Support Phone Number', value: senderData.supportPhone },
        { automationId: 'sender-details-profile-support-instruct', title: 'Special Instructions', value: senderData.specialInstructions },
        { automationId: 'sender-details-profile-support-industry', title: 'Industry', value: senderData.industry },
        { automationId: 'sender-details-profile-support-weblink-dmarc', title: 'DMARC Weblink', value: senderData.dmarcLink },
        { automationId: 'sender-details-profile-support-weblink-spf', title: 'SPF Weblink', value: senderData.spfLink },
        { automationId: 'sender-details-profile-support-weblink-dkim', title: 'DKIM Weblink', value: senderData.dkimLink },
        { automationId: 'sender-details-profile-support-pass-spf', title: 'Able to Pass SPF', value: translate( senderData.passesSPF ) },
        { automationId: 'sender-details-profile-support-align-spf', title: 'Able to Align SPF', value: translate( senderData.alignsSPF ) },
        { automationId: 'sender-details-profile-support-pass-dkim', title: 'Able to Pass DKIM', value: translate( senderData.passesDKIM ) },
        { automationId: 'sender-details-profile-support-align-dkim', title: 'Able to Align DKIM', value: translate( senderData.alignsDKIM ) },
    ];

    const filteredProfileData = allProfileData.filter( ( row ) => {
        return row.value || row.value === false;
    } );

    const logo = senderData.logo ? encodeURI( senderData.logo ) : null;

    return (
        <>
            { senderData.logo &&
                ( <div className={classes.logoContainer}>
                    <img src={logo} alt={`${senderData.name}-logo`} />
                </div> )
            }
            <ColumnedSection data={filteredProfileData} labelWidthPercent={40}/>
        </>
    );
};

SenderDetailsTabProfile.propTypes = {
    classes: PropTypes.object,
    senderData: PropTypes.object,
};

SenderDetailsTabProfile.defaultProps = {
    senderData: {},
};
export default withStyles( styles )( SenderDetailsTabProfile );
